import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

export const DescriptionSectionContainer = styled(Col)`
    width: 100%;
`

export const DescriptionSectionRow = styled(Row)`
    display: flex;
    justify-content: space-between;
`
export const DescriptionSectionRowInfos = styled(Row)`
    width: 100%;
    display: flex;
    justify-content: space-between;

    padding-top: 10px;

    @media only screen and (max-width: 360px) {
        --bs-gutter-x: 0;
    }
    @media only screen and (max-width: 768px) {
        flex-wrap: unset !important;
    }
    @media only screen and (max-width: 540px) {
        flex-wrap: unset !important;
    }
`

export const DescriptionSectionRowCenter = styled(Row)`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
`

export const DescriptionSectionCol = styled(Col)`
    min-height: 48px;
    @media only screen and (max-width: 360px) {
        width: 100%;
        max-width: 100%;
        padding-right: 0;
    }
`

export const DescriptionSectionButtonRow = styled(Row)`
    position: relative;
    height: 102px;
    #timer-description-section {
        bottom: 0;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 10px;
        padding: 0;

        font-family: ${properties => properties.theme.variables.fontFamily.text};
        padding: 0;
        opacity: 0.8;
        font-size: 1rem;
    }
`

export const DescriptionSectionColCenter = styled(Col)`
    display: none;
`

export const DescriptionSectionColEnd = styled(Col)`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
`
export const DescriptionProgressAndCounter = styled.div`
    display: flex;
    align-items: center;
`

export const DescriptionSectionTitle = styled.h3`
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
    letter-spacing: 0.1em;
    color: ${properties => properties.theme.variables.colorText};
    margin-bottom: 5px;

    @media only screen and (min-width: 1179px) {
        font-size: 24px;
    }
    @media only screen and (min-width: 900px) {
        font-size: 20px;
    }
`

export const DescriptionSectionPrice = styled.h3`
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2em;
    margin-bottom: 0.5rem;
    color: ${properties => properties.theme.variables.colorText};
`

interface IDescriptionColTitle {
    isPrice?: boolean
}

export const DescriptionColTitle = styled.h4<IDescriptionColTitle>`
    display: flex;
    width: unset;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    flex-direction: row;
    color: ${properties => properties.theme.variables.colorText};
    span {
        font-family: ${properties => properties.theme.variables.fontFamily.title};
        font-style: normal;
        font-weight: 500;
        opacity: 0.6;
        font-size: 14px;
        color: ${properties => properties.theme.variables.colorText};
        padding-left: 5px;
    }
`

export const DescriptionColSubTitle = styled.h5`
    margin: 0.6rem 0;
    line-height: 150%;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    opacity: 0.8;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
`

export const DescriptionColText = styled.p`
    margin-top: 0.5rem;
    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 500;
    opacity: 0.8;
    font-size: 14px;
    line-height: 13px;
    text-transform: capitalize;
    color: ${properties => properties.theme.variables.colorText};
`

export const DescriptionSectionMintedCounter = styled.span`
    font-family: ${properties => properties.theme.variables.fontFamily.text};
    font-style: normal;
    font-weight: 500;
    font-size: 0.8rem;
    line-height: 16px;
    text-align: right;
    color: ${properties => properties.theme.variables.colorText};
`

export const DescriptionSectionAnchor = styled.a`
    margin-top: 0.2rem;
    height: 13px;

    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 13px;
    text-transform: capitalize;

    color: ${properties => properties.theme.variables.colorPrimary};
    @media only screen and (max-width: 768px) {
        display: block;
        padding-top: 5px;
    }
    @media only screen and (max-width: 540px) {
        display: block;
        padding-top: 5px;
    }
`

export const DescriptionSectionDivider = styled.hr`
    margin: 13px 0;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: ${properties => properties.theme.variables.colorGray.secondary};
    @media only screen and (min-width: 810px) {
        margin: 19px 0;
    }
`
